export default class Utils {
    static getBaseUrl() {
        return 'https://cesarschool.serverest.dev'
    }
} 